









import { ContentV2, ContentType } from '@front-app/services/GroupsApi/DiscussionModel';
import { defineComponent, PropType } from '@vue/composition-api';
import DiscussionContentCard from '@front-app/components/cards/content/DiscussionContentCard.vue';
import LinkContentCard from '@front-app/components/cards/content/LinkContentCard.vue';
import FileContentCard from '@front-app/components/cards/content/FileContentCard.vue';

const CONTENT_CARD_BY_TYPE = {
	[ContentType.DISCUSSION]: DiscussionContentCard,
	[ContentType.LINK]: LinkContentCard,
	[ContentType.FILE]: FileContentCard,
};

export default defineComponent({
	props: {
		content: {
			type: Object as PropType<ContentV2>,
			required: true,
		},
	},
	setup() {
		return {
			CONTENT_CARD_BY_TYPE,
		};
	},
});
